import {React, useEffect} from 'react';
import { useHistory } from "react-router-dom";

const HospitalPlans = () => {
    const history = useHistory();
    useEffect(() => {
       history.push('/hospital-and-clinic-building-designs.php')
      })

    return(
        <></>
    )
}
export default HospitalPlans;